<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="editor-registro">
    <div class="divForm" *ngIf="editRegistroForm">
      <form [formGroup]="editRegistroForm" (onSubmit)="submit()">  
        <ng-container>
          <div class="form-group row">
            <div class="col-sm-12">
              <mat-form-field class="input-select" appearance="outline">
                <mat-label>{{ translation.PlataformasDeVenta }}</mat-label>
                <mat-select
                  multiple
                  placeholder="{{ translation.PlataformasDeVenta }}"
                  formControlName="ListaPlataformas"
                >
                  <mat-option *ngFor="let plataforma of ListaPlataformas" [value]="plataforma.value">
                    {{ translation[plataforma.name] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <app-date-range [group]="editRegistroForm" [translation]="translation"></app-date-range>

          <div class="col-sm-12 mb-5 text-center mt-3">
            <mat-accordion>
              <mat-expansion-panel *ngFor="let idioma of idiomas; let i = index" 
                [expanded]="lineaPanelStep === i" 
                (opened)="setLineaStep(i)" 
                (closed)="closedAccordion(i)"
                #expansionPanel
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ idioma.nombre | translateV2 : "CAPITALIZE" }}
                  </mat-panel-title>
                  <mat-panel-description> </mat-panel-description>
                </mat-expansion-panel-header>

                <ng-container *ngFor="let linea of lineas">          
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ translation[linea] }} {{ '(' + idioma.codIdioma + ')' }}</mat-label>
                          <textarea
                            matInput
                            [formControlName]="linea + '_' + idioma.codIdioma"
                            placeholder="{{ translation.LineaPlaceholder }}">
                          </textarea>
                      </mat-form-field>
                    </div>
                  </div>         
                </ng-container>

              </mat-expansion-panel>
            </mat-accordion>
          </div>
          
          <div class="form-group row">
            <div class="col-sm-12 col-md-12">
              <mat-form-field appearance="outline">
                <mat-select
                  placeholder="{{ translation.Centros }}"
                  formControlName="ClaveCentro"
                  name="ClaveCentro"
                >
                  <mat-option
                    *ngFor="let centro of centros"
                    [value]="centro.nombre"
                  >
                    {{ centro.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>
